import {
  NpsIdentity,
  ReadOfficeDetailFromOrgService,
  StandardCancelFlow,
} from '~/constants/ff.posthog';
import PosthogService from './PosthogService';

export const getShouldReadOfficeDetailFromOrgService = (): boolean =>
  PosthogService.getInstance().isFeatureEnabled(ReadOfficeDetailFromOrgService);

export const getShouldUseNpsIdentity = (): boolean =>
  PosthogService.getInstance().isFeatureEnabled(NpsIdentity);

/** Only the `treatment` arm gets the new cancel flow; control, no value or an unknown arm keep today's. */
export const isStandardCancelArm = (variant: string | boolean | null): boolean =>
  variant === 'treatment';

/** Records the exposure, so call it only when the office starts a cancel; rendering peeks. */
export const getStandardCancelFlow = (): boolean =>
  isStandardCancelArm(PosthogService.getInstance().getFeatureFlagVariant(StandardCancelFlow));

/** Same arm as getStandardCancelFlow, without recording an exposure. */
export const peekStandardCancelFlow = (): boolean =>
  isStandardCancelArm(PosthogService.getInstance().peekFeatureFlagVariant(StandardCancelFlow));
